<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../../app.config";
import axios from 'axios';
import moment from 'moment';
import DataTable from 'datatables.net-vue3';
//import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";
import { usePermissions } from '@/composables/usePermissions';
import Swal from "sweetalert2";

export default {
    page: {
        title: "Aging Report Details",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Aging Report Details",
            items: [
                {
                text: "Aging Report Details",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            aging_listing: [],
            selectedItems: [],
            checkAll: false, 
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
            date: '',
            key_search:'',
            program_id:null,
            programList:null,
            dtKey:0,

            agingReportPeriod : '',
        };
    },
      setup() {
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        formatCurrency(value) {
            let val = (value/1).toFixed(2)
            return "RM " +val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        downloadExcel: function () {
            this.loadingDetail=true;
            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_AR_API_BASEURL+'export/invoiceListingExport', posting_, {responseType: 'blob'})
            .then(response => {
                if (response) {
                    
                    console.log(response);
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
   
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Invoice List.xlsx');
                    document.body.appendChild(fileLink);
   
                    fileLink.click();
                    this.loadingDetail=false;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getInvoiceDetailsListing(){

            if(this.$route.params.aid == 1){
                this.agingReportPeriod = '0 - 30 Days';
            }
            else if (this.$route.params.aid == 2){
                this.agingReportPeriod = '31 - 60 Days';
            }
            else if (this.$route.params.aid == 3){
                this.agingReportPeriod = '61 - 90 Days';
            }
            else if (this.$route.params.aid == 4){
                this.agingReportPeriod = '91 - 120 Days';
            }
            else{
                this.agingReportPeriod = '> 120 Days';
            }

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/agingDetailsListing/'+this.$route.params.aid)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.aging_listing = response.data;
                    //console.log(this.aging_listing);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        searchAgingDetailsListing(e)
        {
            this.loadingRoles=true,
            e.preventDefault()
            
            if(this.aging_range == 1){
                this.agingReportPeriod = '0 - 30 Days';
            }
            else if (this.aging_range == 2){
                this.agingReportPeriod = '31 - 60 Days';
            }
            else if (this.aging_range == 3){
                this.agingReportPeriod = '61 - 90 Days';
            }
            else if (this.aging_range == 4){
                this.agingReportPeriod = '91 - 120 Days';
            }
            else{
                this.agingReportPeriod = '> 120 Days';
            }
            
            const posting_ = {                
                aging_range: this.aging_range,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_AR_API_BASEURL+'invoice/searchAgingDetailsListing', posting_)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.aging_listing = response.data;
                    this.dtKey +=1;
                    console.log(this.aging_listing);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
            this.loadingRoles=false;
        },

        resetForm: function () { 
            this.aging_range = '';
            this.getInvoiceDetailsListing();
        },

        sendReminder()
        {
            Swal.fire({
                title: "Are you sure you want to send email reminder to customer(s)?",
                icon: "info",
                showCancelButton: true,
                cancelButtonColor: "#f46a6a",
                confirmButtonColor: "#34c38f",
                confirmButtonText: "Yes, Send Now",
            }).then((result) => {
                if (result.value) {
                    
                    let selectedValues = [];
                    var checkAll = document.getElementById("checkAll").checked;
                    if (checkAll == true) {
                        const checkboxes = document.querySelectorAll('.form-check-all input[type="checkbox"]'); 
                        selectedValues = Array.from(checkboxes).map(checkbox => checkbox.value);
                    }
                    else{
                        const checkboxes = document.querySelectorAll('.row-checkbox:checked'); 
                        checkboxes.forEach(function(checkbox) {
                            selectedValues.push(checkbox.value);
                        });
                    }

                    if (selectedValues.length === 0) {
                        alert('Please select at least one checkbox.');
                        return;
                    }
                   
                    const posting_ = {
                        'bucket_id'  : this.$route.params.aid,
                        'checked'  : selectedValues,
                    };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_AR_API_BASEURL+'invoice/bucketEmailReminder', posting_ )
                    .then(response => {
                        console.log(response);
                        if (response.status == 201||response.status == 200) {
                            Swal.fire({
                                title:"Email successfully sent.", 
                                icon:"success",
                            })
                        } 
                        else {
                            Swal.fire({
                                title:"Failed to send email.", 
                                icon:"warning",
                            })
                        }
                    }).catch(function (error) {                    
                        Swal.fire({
                            title:error.response.data.msj, 
                            icon:"warning",
                        })
                    });
                }
            });
        },

        // retryCollection()
        // {
        //     Swal.fire({
        //         title: "Are you sure you want to send retry collection?",
        //         icon: "info",
        //         showCancelButton: true,
        //         cancelButtonColor: "#f46a6a",
        //         confirmButtonColor: "#34c38f",
        //         confirmButtonText: "Yes, Send Now",
        //     }).then((result) => {
        //         if (result.value) {
                    
        //             let selectedValues = [];
        //             var checkAll = document.getElementById("checkAll").checked;
        //             if (checkAll == true) {
        //                 const checkboxes = document.querySelectorAll('.form-check-all input[type="checkbox"]'); 
        //                 selectedValues = Array.from(checkboxes).map(checkbox => checkbox.value);
        //             }
        //             else{
        //                 const checkboxes = document.querySelectorAll('.row-checkbox:checked'); 
        //                 checkboxes.forEach(function(checkbox) {
        //                     selectedValues.push(checkbox.value);
        //                 });
        //             }

        //             if (selectedValues.length === 0) {
        //                 alert('Please select at least one checkbox.');
        //                 return;
        //             }
                   
        //             const posting_ = {
        //                 'bucket_id'  : this.$route.params.aid,
        //                 'checked'  : selectedValues,
        //             };
        //             console.log(posting_);
        //             axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        //             axios.post(process.env.VUE_APP_AR_API_BASEURL+'curlect/collection/retry', posting_ )
        //             .then(response => {
        //                 console.log(response);
        //                 // if (response.status == 201||response.status == 200) {
        //                 //     Swal.fire({
        //                 //         title:"Email successfully sent.", 
        //                 //         icon:"success",
        //                 //     })
        //                 // } 
        //                 // else {
        //                 //     Swal.fire({
        //                 //         title:"Failed to send email.", 
        //                 //         icon:"warning",
        //                 //     })
        //                 // }
        //             }).catch(function (error) {                    
        //                 Swal.fire({
        //                     title:error.response.data.msj, 
        //                     icon:"warning",
        //                 })
        //             });
        //         }
        //     });
        // },

        clickCheckAll: function(){ 
            var checkAll = document.getElementById("checkAll");
            //alert(checkAll);
            if (checkAll) {
                var checkboxes = document.querySelectorAll('.form-check-all input[type="checkbox"]'); 
                if (checkAll.checked == true) {
                    checkboxes.forEach(function (checkbox) {
                        checkbox.checked = true;
                    });
                } 
                else 
                {
                    checkboxes.forEach(function (checkbox) {
                        checkbox.checked = false;
                    });
                }
            }
        }, 
    },

    components: {
        Layout,
        PageHeader,
        //flatPickr,
        DataTable,
    },

    mounted() {
        this.getInvoiceDetailsListing();
    },
    
};
require("@/assets/css/datatable.css");
</script>
<style>
/* .col-xl-8 {
    flex: 0 0 auto;
    width: 82.66667% !important;
} */
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!--button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_new_program_modal"  v-if="this.role = 1"><i class="ri-add-line align-middle me-1"></i> Add New Program</button> <br><br-->
        <!--div class="d-flex justify-content-end mb-3">
            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button><br><br>
        </div-->
        <div class="card" v-if="permissions.canRead?.value">
            <!--div class="card-header border-bottom-dashed">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0"></h5>
                        </div>
                    </div>
                    <div class="col-sm-auto">
                        <div class="d-flex justify-content-end mb-3">
                            <button @click="downloadExcel()" class="btn btn-success"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button>
  
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body border-bottom-dashed border-bottom">
                <form @submit="searchAgingDetailsListing">
                <div class="row g-3">
                    <div class="col-xl-12 mb-2">
                        <div class="search-box" id="agingRange">
                            <select v-model="aging_range" class="form-select mb-3" placeholder="Please Select" required>
                                <option value="" disabled selected>---- Please Select ----</option>
                                <option value="1">0 to 30 Days</option>
                                <option value="2">31 to 60 Days</option>
                                <option value="3">61 to 90 Days</option>
                                <option value="4">90 to 120 Days</option>
                                <option value="5">> 120 Days</option>
                            </select>
                        </div>
                    </div>
        
                </div>
                <div class="row g-3 justify-content-end">
                    <div class="col-xl-2">
                        <div>
                            <button type="submit" class="btn btn-primary w-100">
                                <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
                            </button>
                        </div>
                    </div>
                    <div class="col-xl-2">
                        <div>
                            <button @click='resetForm' class="btn btn-danger w-100">
                                <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
                            </button>
                        </div>
                    </div>
                </div>
                </form>
            </div-->
            
            <div class="card-body">
                <div class="col-sm mb-2">
                    <div>
                        <h5 class="card-title mb-0">Aging Report Details : {{ agingReportPeriod }} </h5>
                    </div>
                </div>
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0"></h5>
                        </div>
                    </div>
                    <div class="col-sm-auto">
                        <div class="d-flex justify-content-end mb-3">
                            <button v-if="permissions.canCreate?.value" @click="sendReminder()" class="btn btn-success">Send Reminder</button>
                            <!-- <span class="p-2"></span>
                            <button @click="retryCollection()" class="btn btn-success">Retry Send Collection</button>                             -->
                        </div>
                    </div>
                </div>
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false,searching: false, ordering: false, info: false}" class="table align-middle table-nowrap mb-0" id="customerTable">
                                    <thead class="table-secondary">
                                        <tr>
                                            <th>
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" id="checkAll" @click="clickCheckAll" value="option" />
                                                </div>
                                            </th>       
                                            <th scope="col">Customer Name</th>           
                                            <th scope="col">Phone Number</th>
                                            <th scope="col">Email Address</th>
                                            <th scope="col">Tenure</th>
                                            <th scope="col">Total Outstanding</th>                    
                                        </tr>
                                    </thead>
                                    <tbody class="form-check-all">                        
                                        <tr v-for="(item, index) in aging_listing" :key="index" class="content">
                                            <td>
                                                <div class="form-check">
                                                    <input class="row-checkbox" type="checkbox" v-model="selectedItems" :value="item.customer_id" />
                                                </div>
                                            </td>
                                            <td>{{ item.name_as_per_nric }}</td>                               
                                            <td>{{ item.phone_number }}</td>
                                            <td>{{ item.email }}</td>
                                            <td>{{ item.tenure }}</td>
                                            <td>{{ formatCurrency(item.total_outstanding) }}</td>                                      
                            
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <div v-else class="text-center text-muted p-4">
            You do not have permission to view Aging Report.
     </div>
    </Layout>
</template>